import type {
  MemberPromotionFilters,
  MemberPromotionFiltersParam
} from '@library/types/members/memberPromotions';
import { useCallback, useState } from 'react';
import { defaultPromotionFilters } from '@bo-constants/member/memberPromotions';

export const useMemberPromotionFilters = () => {
  const [memberPromotionFilters, setMemberPromotionFilters] =
    useState<MemberPromotionFilters>(defaultPromotionFilters);

  const handleChangeMemberPromotionFilters = useCallback(
    ({ key, value }: MemberPromotionFiltersParam) => {
      setMemberPromotionFilters({
        ...memberPromotionFilters,
        [key]: value
      });
    },
    [memberPromotionFilters, setMemberPromotionFilters]
  );

  const handleResetMemberPromotionFilters = useCallback(() => {
    setMemberPromotionFilters(defaultPromotionFilters);
  }, []);

  return {
    memberPromotionFilters,
    onChangeMemberPromotionsFilter: handleChangeMemberPromotionFilters,
    onResetMemberPromotionFilters: handleResetMemberPromotionFilters
  };
};
